const CAL_TYPE = {
    SINGLE: 1,
    MULTI: 2,
};

export const DEFAULT_SINGLE_SETTINGS = [
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '0', text: '1 month' },
            { value: '6', text: '6 weeks' },
        ],
        setting_key: 'config-display-weeks',
        setting_val: '0',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-daily-rate',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        can_clear: true,
        setting_key: 'background-rate-daily',
        setting_val: '#fff9c4',
        config: { position: 'bottom left' },
        visible_switch: 'config-daily-rate',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-weekly-rate',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        can_clear: true,
        setting_key: 'background-rate-weekly',
        setting_val: '',
        config: { position: 'bottom left' },
        visible_switch: 'config-weekly-rate',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-discount',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-holiday-shading',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-show-individual-reservations',
        setting_val: '0',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-show-addtl-properties',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-main',
        setting_val: '#ffffff',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-day-can-arrive',
        setting_val: '#eeffff',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-day-can-arrive-triangle',
        setting_val: '#01579b',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-day-can-depart',
        setting_val: '#ffffb3',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-day-can-depart-triangle',
        setting_val: '#c8a415',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-day-busy',
        setting_val: '#fbacab',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-day-selected',
        setting_val: '#00766c',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-nav-current',
        setting_val: '#f32929',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-button-quote',
        setting_val: '#004c40',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-button-book',
        setting_val: '#004c40',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '14', text: '14px' },
            { value: '16', text: '16px' },
            { value: '20', text: '20px' },
            { value: '22', text: '22px' },
            { value: '24', text: '24px' },
        ],
        setting_key: 'config-nav-size',
        setting_val: '20',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '22', text: '22px' },
            { value: '24', text: '24px' },
            { value: '26', text: '26px' },
            { value: '28', text: '28px' },
            { value: '30', text: '30px' },
        ],
        setting_key: 'config-date-size',
        setting_val: '28',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '500', text: 'normal' },
            { value: '700', text: 'bold' },
        ],
        setting_key: 'config-date-weight',
        setting_val: '500',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '12', text: '12px' },
            { value: '14', text: '14px' },
            { value: '16', text: '16px' },
            { value: '18', text: '18px' },
            { value: '20', text: '20px' },
        ],
        setting_key: 'config-alt-date-size',
        setting_val: '16',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '500', text: 'normal' },
            { value: '700', text: 'bold' },
        ],
        setting_key: 'config-alt-date-weight',
        setting_val: '500',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '22', text: '22px' },
            { value: '24', text: '24px' },
            { value: '26', text: '26px' },
            { value: '28', text: '28px' },
            { value: '30', text: '30px' },
        ],
        setting_key: 'config-arrow-size',
        setting_val: '26',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-show-property-name',
        setting_val: '0',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-booking-in-new-tab',
        setting_val: '0',
    },
];

export const DEFAULT_SINGLE_SETTINGS_FOR_RESET = [
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '0', text: '1 month' },
            { value: '6', text: '6 weeks' },
        ],
        setting_key: 'config-display-weeks',
        setting_val: '0',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-daily-rate',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        can_clear: true,
        setting_key: 'background-rate-daily',
        setting_val: '#fff9c4',
        config: { position: 'bottom left' },
        visible_switch: 'config-daily-rate',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-weekly-rate',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        can_clear: true,
        setting_key: 'background-rate-weekly',
        setting_val: '',
        config: { position: 'bottom left' },
        visible_switch: 'config-weekly-rate',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-discount',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-holiday-shading',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-show-individual-reservations',
        setting_val: '0',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-show-addtl-properties',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-main',
        setting_val: '#ffffff',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-day-can-arrive',
        setting_val: '#eeffff',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-day-can-arrive-triangle',
        setting_val: '#01579b',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-day-can-depart',
        setting_val: '#ffffb3',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-day-can-depart-triangle',
        setting_val: '#c8a415',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-day-busy',
        setting_val: '#fbacab',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-day-selected',
        setting_val: '#00766c',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-nav-current',
        setting_val: '#f32929',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-button-quote',
        setting_val: '#004c40',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'color',
        setting_key: 'background-button-book',
        setting_val: '#004c40',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '14', text: '14px' },
            { value: '16', text: '16px' },
            { value: '20', text: '20px' },
            { value: '22', text: '22px' },
            { value: '24', text: '24px' },
        ],
        setting_key: 'config-nav-size',
        setting_val: '20',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '22', text: '22px' },
            { value: '24', text: '24px' },
            { value: '26', text: '26px' },
            { value: '28', text: '28px' },
            { value: '30', text: '30px' },
        ],
        setting_key: 'config-date-size',
        setting_val: '28',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '500', text: 'normal' },
            { value: '700', text: 'bold' },
        ],
        setting_key: 'config-date-weight',
        setting_val: '500',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '12', text: '12px' },
            { value: '14', text: '14px' },
            { value: '16', text: '16px' },
            { value: '18', text: '18px' },
            { value: '20', text: '20px' },
        ],
        setting_key: 'config-alt-date-size',
        setting_val: '16',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '500', text: 'normal' },
            { value: '700', text: 'bold' },
        ],
        setting_key: 'config-alt-date-weight',
        setting_val: '500',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'select',
        options: [
            { value: '22', text: '22px' },
            { value: '24', text: '24px' },
            { value: '26', text: '26px' },
            { value: '28', text: '28px' },
            { value: '30', text: '30px' },
        ],
        setting_key: 'config-arrow-size',
        setting_val: '26',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-show-property-name',
        setting_val: '0',
    },
    {
        calendar_type: CAL_TYPE.SINGLE,
        field_type: 'switch',
        setting_key: 'config-booking-in-new-tab',
        setting_val: '0',
    },
];

export const SINGLE_SETTINGS_GROUPS = [
    {
        label: 'Layout:',
        keys: ['config-display-weeks'],
    },
    {
        label: 'Nightly Rate:',
        keys: ['background-rate-daily', 'config-daily-rate'],
    },
    {
        label: 'Weekly Rate:',
        keys: ['background-rate-weekly', 'config-weekly-rate'],
    },
    {
        label: 'Discounts:',
        keys: ['config-discount'],
    },
    {
        label: 'Holiday Shading:',
        keys: ['config-holiday-shading'],
    },
    {
        label: 'Show Same Day Turnovers:',
        keys: ['config-show-individual-reservations'],
    },
    {
        label: 'Ask to Add Another Property:',
        keys: ['config-show-addtl-properties'],
    },
    {
        label: 'Main Bkgrd:',
        keys: ['background-main'],
    },
    {
        label: 'Arrive Day Bkgrd:',
        keys: ['background-day-can-arrive'],
    },
    {
        label: 'Arrive Day Arrow Color:',
        keys: ['background-day-can-arrive-triangle'],
    },
    {
        label: 'Depart Day Bkgrd:',
        keys: ['background-day-can-depart'],
    },
    {
        label: 'Depart Day Arrow Color:',
        keys: ['background-day-can-depart-triangle'],
    },
    {
        label: 'Not Available Day Bkgrd:',
        keys: ['background-day-busy'],
    },
    {
        label: 'Selected Day Bkgrd:',
        keys: ['background-day-selected'],
    },
    {
        label: 'Current Month And Year:',
        keys: ['background-nav-current'],
    },
    {
        label: 'Email Quote Button:',
        keys: ['background-button-quote'],
    },
    {
        label: 'Book Button:',
        keys: ['background-button-book'],
    },
    {
        label: 'Current Month Font Size:',
        keys: ['config-nav-size'],
    },
    {
        label: 'Date Font:',
        keys: ['config-date-size', 'config-date-weight'],
    },
    {
        label: 'Alt Date Font:',
        keys: ['config-alt-date-size', 'config-alt-date-weight'],
        visible_switch: 'config-display-weeks',
        visible_switch_value: '6',
    },
    {
        label: 'Arrow Size:',
        keys: ['config-arrow-size'],
    },
    {
        label: 'Property Name In Embed Code:',
        keys: ['config-show-property-name'],
    },
    {
        label: 'Booking In New Tab:',
        keys: ['config-booking-in-new-tab'],
    },
];

export const DEFAULT_MULTI_SETTINGS = [
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select',
        options: [
            { value: '0', text: 'Auto' },
            { value: '100', text: '100px' },
            { value: '110', text: '110px' },
            { value: '120', text: '120px' },
            { value: '130', text: '130px' },
            { value: '140', text: '140px' },
            { value: '150', text: '150px' },
            { value: '160', text: '160px' },
            { value: '170', text: '170px' },
            { value: '180', text: '180px' },
            { value: '190', text: '190px' },
            { value: '200', text: '200px' },
            { value: '210', text: '210px' },
            { value: '220', text: '220px' },
            { value: '230', text: '230px' },
            { value: '240', text: '240px' },
            { value: '250', text: '250px' },
        ],
        setting_key: 'config-property-name-width',
        setting_val: '0',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-rates-text',
        setting_val: '0',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-beds-baths-sleeps',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-nightly-rates',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'color-rate-nightly',
        setting_val: '#212121',
        config: { position: 'bottom left' },
        visible_switch: 'config-show-nightly-rates',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-weekly-rates',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'color-rate-weekly',
        setting_val: '#212121',
        config: { position: 'bottom left' },
        visible_switch: 'config-show-weekly-rates',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-discounts',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'color-discount',
        setting_val: '#d00000',
        config: { position: 'bottom left' },
        visible_switch: 'config-show-discounts',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-call-to-book',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select',
        options: [
            { value: 'half', text: 'Half' },
            { value: 'diagonal', text: 'Diagonal' },
            { value: 'full', text: 'Full' },
        ],
        setting_key: 'config-availability-type',
        setting_val: 'diagonal',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-turnovers',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select',
        options: [
            { value: '0', text: 'Conventional' },
            { value: '1', text: 'Settings' },
        ],
        setting_key: 'config-weekend-shading',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-holiday-shading',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-categories',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-booked-text',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-addtl-properties',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-filters',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'date',
        setting_key: 'config-initial-date',
        setting_val: '',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select',
        options: [
            { value: '9', text: '9px' },
            { value: '10', text: '10px' },
            { value: '11', text: '11px' },
            { value: '12', text: '12px' },
            { value: '13', text: '13px' },
            { value: '14', text: '14px' },
        ],
        setting_key: 'config-grid-font',
        setting_val: '9',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select',
        options: [
            { value: '28', text: 'Small' },
            { value: '38', text: 'Medium' },
            { value: '48', text: 'Large' },
        ],
        setting_key: 'config-grid-row-height',
        setting_val: '38',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select',
        options: [
            { value: '28', text: 'Small' },
            { value: '38', text: 'Medium' },
            { value: '48', text: 'Large' },
        ],
        setting_key: 'config-grid-cell-width',
        setting_val: '38',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-main',
        setting_val: '#ffffff',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-category',
        setting_val: '#e0e0e0',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-today',
        setting_val: '#ffac1c',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-arrive',
        setting_val: '#e0ffff',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-arrive-arrow',
        setting_val: '#0d47a1',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-depart',
        setting_val: '#ffffb3',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-depart-arrow',
        setting_val: '#c8a415',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'bg-reservation-use-scheme',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select_color',
        options: [
            '#99e1e5|#f3e8cb|#f2c6b4|#fbafaf',
            '#35477d|#6c5b7b|#c06c84|#f67280',
            '#f76262|#216583|#65c0ba|#cffdf8',
            '#ffffc1|#ffd2a5|#d38cad|#8a79af',
            '#f5eee6|#f3d7ca|#e6a4b4|#c86b85',
            '#eda1c1|#fab2ac|#bee4d2|#d7f8f7',
            '#480032|#df0054|#ff8b6a|#ffd2bb',
            '#1a2c5b|#3e4e88|#7971ea|#b8dff0',
            '#f5f5c6|#7da87b|#326765|#27253d',
            '#0e3150|#6dc9c8|#ffc0c2|#f7e9e3',
            '#535238|#4bbb8b|#6ddabe|#c9ffc7',
            '#424153|#fdadc7|#ea4c88|#993399',
            '#ffa258|#fff7c2|#a02a63|#4b125c',
            '#233142|#455d7a|#f95959|#facf5a',
            '#7c203a|#f85959|#ff9f68|#feff89',
            '#fffdb7|#aef4a4|#79b8d1|#e36488',
            '#f5b17b|#4e709d|#89a4c7|#cdd5e0',
            '#7a4579|#d56073|#ec9e69|#ffff8f',
            '#182952|#2b3595|#7045af|#e14594',
            '#ff9900|#ca431d|#8b104e|#520556',
            '#87e5da|#92a4c0|#f4adad|#e58cdb',
            '#363434|#5c5757|#62929a|#efecec',
        ],
        setting_key: 'bg-reservation-scheme',
        setting_val: '#99e1e5|#f3e8cb|#f2c6b4|#fbafaf',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-reservation',
        setting_val: '#fbacab',
        config: { position: 'bottom left' },
        visible_switch: 'bg-reservation-use-scheme',
        visible_switch_value: '0',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-selection',
        setting_val: '#00766c',
        config: { position: 'top left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-button-quote',
        setting_val: '#004c40',
        config: { position: 'top left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-button-book',
        setting_val: '#004c40',
        config: { position: 'top left' },
    },
];

export const DEFAULT_MULTI_SETTINGS_FOR_RESET = [
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select',
        options: [
            { value: '0', text: 'Auto' },
            { value: '100', text: '100px' },
            { value: '110', text: '110px' },
            { value: '120', text: '120px' },
            { value: '130', text: '130px' },
            { value: '140', text: '140px' },
            { value: '150', text: '150px' },
            { value: '160', text: '160px' },
            { value: '170', text: '170px' },
            { value: '180', text: '180px' },
            { value: '190', text: '190px' },
            { value: '200', text: '200px' },
            { value: '210', text: '210px' },
            { value: '220', text: '220px' },
            { value: '230', text: '230px' },
            { value: '240', text: '240px' },
            { value: '250', text: '250px' },
        ],
        setting_key: 'config-property-name-width',
        setting_val: '0',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-rates-text',
        setting_val: '0',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-beds-baths-sleeps',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-nightly-rates',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'color-rate-nightly',
        setting_val: '#212121',
        config: { position: 'bottom left' },
        visible_switch: 'config-show-nightly-rates',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-weekly-rates',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'color-rate-weekly',
        setting_val: '#212121',
        config: { position: 'bottom left' },
        visible_switch: 'config-show-weekly-rates',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-discounts',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'color-discount',
        setting_val: '#d00000',
        config: { position: 'bottom left' },
        visible_switch: 'config-show-discounts',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-call-to-book',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select',
        options: [
            { value: 'half', text: 'Half' },
            { value: 'diagonal', text: 'Diagonal' },
            { value: 'full', text: 'Full' },
        ],
        setting_key: 'config-availability-type',
        setting_val: 'diagonal',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-turnovers',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select',
        options: [
            { value: '0', text: 'Conventional' },
            { value: '1', text: 'Settings' },
        ],
        setting_key: 'config-weekend-shading',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-holiday-shading',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-categories',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-booked-text',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-addtl-properties',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'config-show-filters',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'date',
        setting_key: 'config-initial-date',
        setting_val: '',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select',
        options: [
            { value: '9', text: '9px' },
            { value: '10', text: '10px' },
            { value: '11', text: '11px' },
            { value: '12', text: '12px' },
            { value: '13', text: '13px' },
            { value: '14', text: '14px' },
        ],
        setting_key: 'config-grid-font',
        setting_val: '9',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select',
        options: [
            { value: '28', text: 'Small' },
            { value: '38', text: 'Medium' },
            { value: '48', text: 'Large' },
        ],
        setting_key: 'config-grid-row-height',
        setting_val: '38',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select',
        options: [
            { value: '28', text: 'Small' },
            { value: '38', text: 'Medium' },
            { value: '48', text: 'Large' },
        ],
        setting_key: 'config-grid-cell-width',
        setting_val: '38',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-main',
        setting_val: '#ffffff',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-category',
        setting_val: '#e0e0e0',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-today',
        setting_val: '#ffac1c',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-arrive',
        setting_val: '#e0ffff',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-arrive-arrow',
        setting_val: '#0d47a1',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-depart',
        setting_val: '#ffffb3',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-depart-arrow',
        setting_val: '#c8a415',
        config: { position: 'bottom left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'switch',
        setting_key: 'bg-reservation-use-scheme',
        setting_val: '1',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'select_color',
        options: [
            '#99e1e5|#f3e8cb|#f2c6b4|#fbafaf',
            '#35477d|#6c5b7b|#c06c84|#f67280',
            '#f76262|#216583|#65c0ba|#cffdf8',
            '#ffffc1|#ffd2a5|#d38cad|#8a79af',
            '#f5eee6|#f3d7ca|#e6a4b4|#c86b85',
            '#eda1c1|#fab2ac|#bee4d2|#d7f8f7',
            '#480032|#df0054|#ff8b6a|#ffd2bb',
            '#1a2c5b|#3e4e88|#7971ea|#b8dff0',
            '#f5f5c6|#7da87b|#326765|#27253d',
            '#0e3150|#6dc9c8|#ffc0c2|#f7e9e3',
            '#535238|#4bbb8b|#6ddabe|#c9ffc7',
            '#424153|#fdadc7|#ea4c88|#993399',
            '#ffa258|#fff7c2|#a02a63|#4b125c',
            '#233142|#455d7a|#f95959|#facf5a',
            '#7c203a|#f85959|#ff9f68|#feff89',
            '#fffdb7|#aef4a4|#79b8d1|#e36488',
            '#f5b17b|#4e709d|#89a4c7|#cdd5e0',
            '#7a4579|#d56073|#ec9e69|#ffff8f',
            '#182952|#2b3595|#7045af|#e14594',
            '#ff9900|#ca431d|#8b104e|#520556',
            '#87e5da|#92a4c0|#f4adad|#e58cdb',
            '#363434|#5c5757|#62929a|#efecec',
        ],
        setting_key: 'bg-reservation-scheme',
        setting_val: '#99e1e5|#f3e8cb|#f2c6b4|#fbafaf',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-reservation',
        setting_val: '#fbacab',
        config: { position: 'bottom left' },
        visible_switch: 'bg-reservation-use-scheme',
        visible_switch_value: '0',
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-selection',
        setting_val: '#00766c',
        config: { position: 'top left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-button-quote',
        setting_val: '#004c40',
        config: { position: 'top left' },
    },
    {
        calendar_type: CAL_TYPE.MULTI,
        field_type: 'color',
        setting_key: 'bg-button-book',
        setting_val: '#004c40',
        config: { position: 'top left' },
    },
];

export const MULTI_SETTINGS_GROUPS = [
    {
        label: 'Property Name Width:',
        keys: ['config-property-name-width'],
    },
    {
        label: 'Rates Text:',
        keys: ['config-show-rates-text'],
    },
    {
        label: 'Beds/Baths/Sleeps:',
        keys: ['config-show-beds-baths-sleeps'],
    },
    {
        label: 'Nightly Rate:',
        keys: ['color-rate-nightly', 'config-show-nightly-rates'],
    },
    {
        label: 'Weekly Rate:',
        keys: ['color-rate-weekly', 'config-show-weekly-rates'],
    },
    {
        label: 'Discount:',
        keys: ['color-discount', 'config-show-discounts'],
    },
    {
        label: 'Call To Book Icon:',
        keys: ['config-show-call-to-book'],
    },
    {
        label: 'Availability Type:',
        keys: ['config-availability-type'],
    },
    {
        label: 'Show Turnovers:',
        keys: ['config-show-turnovers'],
    },
    {
        label: 'Weekend Shading:',
        keys: ['config-weekend-shading'],
    },
    {
        label: 'Holiday Shading:',
        keys: ['config-holiday-shading'],
    },
    {
        label: 'Categories:',
        keys: ['config-categories'],
    },
    {
        label: 'Booked Text:',
        keys: ['config-show-booked-text'],
    },
    {
        label: 'Ask to Add Another Property:',
        keys: ['config-show-addtl-properties'],
    },
    {
        label: 'Filters:',
        keys: ['config-show-filters'],
    },
    {
        label: 'Initial Date:',
        keys: ['config-initial-date'],
    },
    {
        label: 'Grid Font Size:',
        keys: ['config-grid-font'],
    },
    {
        label: 'Grid Row Height:',
        keys: ['config-grid-row-height'],
    },
    {
        label: 'Grid Cell Width:',
        keys: ['config-grid-cell-width'],
    },
    {
        label: 'Main Bkgrd:',
        keys: ['bg-main'],
    },
    {
        label: 'Category Bkgrd:',
        keys: ['bg-category'],
    },
    {
        label: 'Current Day Bkgrd:',
        keys: ['bg-today'],
    },
    {
        label: 'Arrive Day Bkgrd:',
        keys: ['bg-arrive'],
    },
    {
        label: 'Arrive Day Arrow Color:',
        keys: ['bg-arrive-arrow'],
    },
    {
        label: 'Depart Day Bkgrd:',
        keys: ['bg-depart'],
    },
    {
        label: 'Depart Day Arrow Color:',
        keys: ['bg-depart-arrow'],
    },
    {
        label: 'Reservation Coloring Scheme:',
        keys: ['bg-reservation-use-scheme'],
    },
    {
        keys: ['bg-reservation-scheme'],
        visible_switch: 'bg-reservation-use-scheme',
    },
    {
        label: 'Reservation Bkgrd:',
        keys: ['bg-reservation'],
        visible_switch: 'bg-reservation-use-scheme',
        visible_switch_value: '0',
    },
    {
        label: 'Selected Day Bkgrd:',
        keys: ['bg-selection'],
    },
    {
        label: 'Email Quote Button:',
        keys: ['bg-button-quote'],
    },
    {
        label: 'Book Button:',
        keys: ['bg-button-book'],
    },
];
